import React, { useState, useEffect } from "react"
import { Breadcrumb, Layout, Menu, Modal, Popover, Select, Switch, Table, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";
import "../../index.css"



const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const DirectCareReport
    = () => {



        const [modal1Open, setModal1Open] = useState(false);
        const [modal2Open, setModal2Open] = useState(false);
        const [modal3Open, setModal3Open] = useState(false);
        const [modal4Open, setModal4Open] = useState(false);
        const [modal5Open, setModal5Open] = useState(false);
        const [modal6Open, setModal6Open] = useState(false);

        const navigate = useNavigate()
        // tab switch
        const [selectedTab, setSelectedTab] = useState(1);

        // popover 
        const [open, setOpen] = useState(false);
        const hide = () => {
            setOpen(false);
        };
        const handleOpenChange = (newOpen) => {
            setOpen(newOpen);
        };
        // end popover

        // 
        const [open1, setOpen1] = useState(false);
        const hide1 = () => {
            setOpen1(false);
        };

        const handleOpenChange1 = (newOpen) => {
            setOpen1(newOpen);
        };

        // 

        useEffect(() => {
            document.title = 'MentalFit';
        }, [])

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        // 




        // second table



        const dataSource2 = [

            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },

            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },


            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },


            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },


            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },


            {
                key: '1',
                participant: 'Annette Black',
                users: "qfpm6",
                date: "March 23, 2013",
                ratings: "4.9",
                status: "",
                earnings: "$1,000",
            },
        ];

        const columns2 = [{
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            sorter: false,
            render: (value, item, index) => (index + 1)
        },

        {
            title: 'Participant  ',
            dataIndex: 'participant',
            key: 'participant',
            sorter: false,
            render: (value, item, index) =>
                <div className="organization-image-sec">
                    <span><img src={images.maleTable} /></span>
                    {item.participant}
                </div>
        },


        {
            title: 'Username',
            dataIndex: 'users',
            key: 'users',
            sorter: false,
        },

        {
            title: 'Date & Time',
            dataIndex: 'date',
            key: 'date',
            sorter: false,
            render: (value, item, index) =>
                <div className="table-tb-plan">
                    {item.date} <p>Join Date: May 6, 2012</p>
                </div>
        },

        {
            title: 'Ratings',
            dataIndex: 'ratings',
            key: 'ratings',
            sorter: false,
            render: (value, item, index) =>
                <div className="organization-image-sec">
                    <span><img src={images.starFill} /></span>
                    {item.ratings}
                </div>

        },


        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: false,
            render: (value, item, index) => <div className="status-active">
                <span>Done</span>
            </div>
        },
        {
            title: 'Earned',
            dataIndex: 'earnings',
            key: 'earnings',
            sorter: false,
        },


        {
            title: 'Action',
            dataIndex: 'Posted',
            key: 'Posted',
            render: () => {
                return (

                    <div className="action-dots-iocn">
                        <span ><img src={images.horizontalDots} /></span>
                    </div>
                )
            }
        },
        ];


        // therd table


        const dataSource3 = [
            {
                key: '1',
                date: "March 23, 2013",
                activity: "Received",
                amount: "$1,000",
            },
            {
                key: '1',
                date: "March 23, 2013",
                activity: "Received",
                amount: "$1,000",
            },

            {
                key: '1',
                date: "March 23, 2013",
                activity: "Received",
                amount: "$1,000",
            },


            {
                key: '1',
                date: "March 23, 2013",
                activity: "Received",
                amount: "$1,000",
            },

            {
                key: '1',
                date: "March 23, 2013",
                activity: "Received",
                amount: "$1,000",
            },
        ];

        const columns3 = [{
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            sorter: false,
            render: (value, item, index) => (index + 1)
        },




        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: false,

        },

        {
            title: 'Activity',
            dataIndex: 'activity',
            key: 'activity',
            sorter: false,
            render: (value, item, index) =>
                <div className="organization-image-sec">
                    {item.activity} <span><img src={images.uploadIcon} /></span>
                </div>
        },



        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            sorter: false,
        },


        {
            title: 'Action',
            dataIndex: 'Posted',
            key: 'Posted',
            render: () => {
                return (

                    <div className="action-dots-iocn">
                        <span ><img src={images.horizontalDots} /></span>
                    </div>
                )
            }
        },
        ];


        // 


        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Direct Care Report</h1>
                            <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                        </div>
                    </div>


                    <div className="user-main-section">
                        <div className="user-profile-div">
                            <div className="user-left-side-sec">
                                <div className="inner-section-ps">
                                    <div className="avt-profile-pic">
                                        <img src={images.avatarWith} alt="avatarWith" />
                                    </div>


                                    <div className="avatar-name">
                                        <h2> John_adam06</h2>
                                        <p>Bessie_Cooper12</p>
                                        <div className="avatar-ranking pink-star">
                                            <img src={images.pinkStar} alt="pinkStar" />
                                            <img src={images.pinkStar} alt="pinkStar" />
                                            <img src={images.pinkStar} alt="pinkStar" />
                                            <img src={images.pinkStar} alt="pinkStar" />
                                            <img src={images.pinkStar} alt="pinkStar" />
                                            <p>5.0</p>
                                        </div>
                                    </div>

                                    <div className="followers-section">
                                        <div className="avatar-post-numbers direct_care_report-flex">
                                            <div className="following-div border-line">
                                                <p>40</p>
                                                <span>Followers</span>
                                            </div>

                                            <div className="following-div border-line">
                                                <p>5 yr</p>
                                                <span>Experience</span>
                                            </div>

                                            <div className="following-div border-line">
                                                <p>20</p>
                                                <span>Posts</span>
                                            </div>

                                            <div className="following-div">
                                                <p>10</p>
                                                <span>Sessions</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="work-on-most">


                                        <div className="primary-expertise-text-bold">
                                            <h2>Primary Expertise</h2>
                                            <p>Stress, Addictions, Depression,Anxiety</p>
                                        </div>

                                        <div className="primary-expertise-text-bold">
                                            <h2>Secondary Expertise</h2>
                                            <p>Stress, Addictions, Depression,Anxiety</p>
                                        </div>


                                        <div className="primary-expertise-text-bold">
                                            <h2>Bio</h2>
                                            <p>Alit, sed do eiusmod tempor see more</p>
                                        </div>

                                        <div className="top-mt">
                                            <div className="coins">
                                                <p>Coins</p>
                                                <span><img src={images.coins} alt="coins" />500</span>
                                            </div>

                                            <div className="coins">
                                                <p>Email</p>
                                                <span>ckctm12@gmail.com</span>
                                            </div>

                                            <div className="coins">
                                                <p>Gender</p>
                                                <span>Male</span>
                                            </div>


                                            <div className="coins">
                                                <p>DOB </p>
                                                <span>March 23, 2013</span>
                                            </div>

                                            <div className="coins">
                                                <p>Visibility</p>
                                                <span>On</span>
                                            </div>

                                            <div className="coins">
                                                <p>WHO-5 Wellness Index</p>
                                                <span>200</span>
                                            </div>


                                            <div className="coins">
                                                <p>Streak</p>
                                                <span>50 Days</span>
                                            </div>
                                        </div>
                                        <div className="profile-freeze">
                                            <button onClick={() => setModal3Open(true)}>Freeze Profile</button>
                                            <button onClick={() => setModal5Open(true)} >Remove Profile</button>
                                        </div>
                                    </div>

                                    <div className="bottom-text">
                                        <p>Member Since: March 23, 2013 </p>
                                    </div>

                                </div>

                            </div>



                            <div className=" post-page-section">


                                <div className="gratitude-attitude-new-sec top-bottom-margin-sp">
                                    <div className="problem-type-hate">
                                        <div className="hate-speech">
                                            <div className="problem-type">
                                                <p>Report Reason</p>
                                                <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lore m ipsum dolor sit amet, </h6>
                                            </div>
                                            <div className="post-cont">
                                                <Popover
                                                    content={
                                                        <div className="popup" style={{ width: "200px" }}>
                                                            <div onClick={() => {
                                                                setModal1Open(true)
                                                                setOpen1(false)
                                                            }} className="edit-account">
                                                                <p><span><img src={images.crossSquar} alt="crossSquar" /></span>Remove User</p>
                                                            </div>
                                                            <div onClick={() => {
                                                                setModal2Open(true)
                                                                setOpen1(false)
                                                            }} className="edit-account freeze-account">
                                                                <p><span><img src={images.freezeUserIcon} alt="freezeUserIcon" /></span>Freeze User</p>
                                                            </div>
                                                            <div className="edit-account freeze-account">
                                                                <p><span><img src={images.rightClick} alt="rightClick" /></span>Ignore</p>
                                                            </div>

                                                        </div>

                                                    }
                                                    title=""
                                                    trigger="click"
                                                    placement="bottomLeft"
                                                    overlayClassName="update-popup"
                                                    open={open1}
                                                    onOpenChange={handleOpenChange1}
                                                >

                                                    <img src={images.horizontalDots} alt="horizontalDots" />
                                                </Popover>

                                                {/* <img src={images.horizontalDots} /> */}
                                            </div>
                                        </div>

                                        <div className="annette-black-avatar">
                                            <div className="black-avatar">
                                                <p> <span><img src={images.maleTable} /> </span> Annette Black</p>
                                            </div>

                                            <div className="black-avatar-date">
                                                <p>March 23, 2013</p>

                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <div className="appointment-rates-sections">
                                    <div className="left-side-appointment">
                                        <h2>Appointment Rates</h2>

                                        <div className="appoint-ment-grid-div">
                                            <div className="min-box">
                                                <p>15 min</p>
                                                <h1>$50</h1>
                                            </div>

                                            <div className="min-box">
                                                <p>30 min</p>
                                                <h1>$100</h1>
                                            </div>


                                            <div className="min-box">
                                                <p>45 min</p>
                                                <h1>$150</h1>
                                            </div>


                                            <div className="min-box">
                                                <p>1 hour</p>
                                                <h1>$200</h1>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="left-side-appointment right-side-widht-set">
                                        <h2>Earnings</h2>

                                        <div className="amount-withdrawn">
                                            <p>Amount Withdrawn</p>
                                            <span>$5,000</span>
                                        </div>

                                        <div className="amount-withdrawn">
                                            <p>Available Earnings</p>
                                            <span>$5,000</span>
                                        </div>

                                    </div>

                                </div>

                                <div className="slider-tab-div slider-section  " >

                                    <div className="tab-bar">
                                        <Tabs>
                                            <Tabs.TabPane tab="Sessions" key="1">

                                                <div className="content-e outter-space">
                                                    <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                                                        <input type="text" className="iocn-search  search-bar" placeholder="Search" />

                                                        <div className="top-checkbox">
                                                            <Select
                                                                defaultValue="Filter"
                                                                onChange={handleChange}
                                                                options={[
                                                                    { value: 'one', label: '1 months' },
                                                                    { value: 'two', label: '3 months' },
                                                                    { value: 'three', label: '6 months' },

                                                                ]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <Table dataSource={dataSource2} columns={columns2} showSorterTooltip={false} />

                                                    <div className="footer-section">
                                                        <div className="foot-main-div">
                                                            <div className="rows">
                                                                <div className="row-per-page">
                                                                    <p>Rows per page</p>
                                                                </div>

                                                                <div className="top-checkbox fot-select">
                                                                    <Select
                                                                        defaultValue="10"
                                                                        onChange={handleChange}
                                                                        options={[
                                                                            { value: 'one', label: '15 ' },
                                                                            { value: 'two', label: '20' },
                                                                            { value: 'three', label: '25' },

                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="page-count">
                                                                <p>1-10 of 100</p>
                                                            </div>

                                                            <div className="back-and-next">
                                                                <span><img src={images.back} alt="back" /></span>
                                                                <span><img src={images.per} alt="back" /></span>
                                                                <span><img src={images.new} alt="back" /></span>
                                                                <span><img src={images.next} alt="back" /></span>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>

                                            </Tabs.TabPane>

                                            <Tabs.TabPane tab="Transactions History" key="2">


                                                <div className="content-e outter-space">


                                                    <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                                                        <input type="text" className="iocn-search  search-bar" placeholder="Search" />

                                                        <div className="top-checkbox">
                                                            <Select
                                                                defaultValue="Filter"
                                                                onChange={handleChange}
                                                                options={[
                                                                    { value: 'one', label: '1 months' },
                                                                    { value: 'two', label: '3 months' },
                                                                    { value: 'three', label: '6 months' },

                                                                ]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <Table dataSource={dataSource3} columns={columns3} showSorterTooltip={false} />

                                                    <div className="footer-section">
                                                        <div className="foot-main-div">
                                                            <div className="rows">
                                                                <div className="row-per-page">
                                                                    <p>Rows per page</p>
                                                                </div>

                                                                <div className="top-checkbox fot-select">
                                                                    <Select
                                                                        defaultValue="10"
                                                                        onChange={handleChange}
                                                                        options={[
                                                                            { value: 'one', label: '15 ' },
                                                                            { value: 'two', label: '20' },
                                                                            { value: 'three', label: '25' },

                                                                        ]}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="page-count">
                                                                <p>1-10 of 100</p>
                                                            </div>

                                                            <div className="back-and-next">
                                                                <span><img src={images.back} alt="back" /></span>
                                                                <span><img src={images.per} alt="back" /></span>
                                                                <span><img src={images.new} alt="back" /></span>
                                                                <span><img src={images.next} alt="back" /></span>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>

                                            </Tabs.TabPane>


                                            <Tabs.TabPane tab="Posts" key="3">

                                                <div className="post-page-width">
                                                    <div className="user-post remove-the-sp">

                                                        <div className="post-rmover-setting">
                                                            <div className="post-disp">
                                                                <div className="user-pofile">
                                                                    <img src={images.johnAvatar} alt="johnAvatar" />
                                                                </div>
                                                                <div className="user-name">
                                                                    <h2>John_adam06</h2>
                                                                    <p>1 hr ago</p>
                                                                </div>
                                                            </div>

                                                            <div className="update-btn-right padding-right">
                                                                <span>

                                                                    <Popover
                                                                        content={
                                                                            <div className="popup" style={{ width: "200px" }}>
                                                                                <div className="edit-account">
                                                                                    <p><span><img src={images.crossSquar} alt="lineDev" /></span>Remove Post</p>
                                                                                </div>


                                                                            </div>

                                                                        }
                                                                        title=""
                                                                        trigger="click"
                                                                        placement="bottomRight"
                                                                        overlayClassName="update-popup"
                                                                        open={open}
                                                                        onOpenChange={handleOpenChange}
                                                                    >

                                                                        <img src={images.dotesReact} alt="horizontalDots" />
                                                                    </Popover>
                                                                </span>
                                                            </div>

                                                        </div>



                                                        <div className="user-disp-text john-profile">
                                                            <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                                                        </div>

                                                        <div className="post-image">
                                                            <img src={images.post} alt="firstIcon" />
                                                        </div>

                                                        <div className=" comment-sec">
                                                            <div>
                                                                {/* <img src={images.dotesReact} alt="userProf" /> */}
                                                            </div>

                                                            <div className="like-and-imozes">
                                                                <img src={images.commentIcon} alt="commentIcon" />
                                                                <img src={images.imozeIcon} alt="imozeIcon" />

                                                            </div>
                                                        </div>
                                                    </div>




                                                </div>


                                            </Tabs.TabPane>


                                            <Tabs.TabPane tab="Inner circles" key="4">

                                                <div className="inner-circle">
                                                    <div className="create-inner-section">


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>

                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>




                                                        <div className="create-entertainment-circle">
                                                            <div className="enter-flex-ps">
                                                                <div className="enter-taain-heading">
                                                                    <h1>Entertainment</h1>
                                                                    <p><span><img src={images.redDot} alt="createCricl" />
                                                                    </span>Circle activity tomorrow at 10:00 AM</p>
                                                                </div>
                                                                <div className="dotes-react">
                                                                    {/* <img src={images.dotesReact} alt="dotesReact" /> */}

                                                                </div>

                                                            </div>

                                                            <div className="reation-imoze">
                                                                <div className="avatars">
                                                                    <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                                    <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                                    <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                                    <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                                    <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                                    <span className="get-more">+3</span>
                                                                </div>

                                                                <div className="back-button">
                                                                    <img src={images.backButton} alt="backButton" />
                                                                </div>
                                                            </div>

                                                            <div className="engagement-rate">
                                                                <div className="engage-text">
                                                                    <h5>Engagement Rate</h5>
                                                                </div>
                                                                <div className="per-rate">
                                                                    <span>90%</span>

                                                                </div>
                                                            </div>


                                                        </div>


                                                    </div>

                                                </div>


                                            </Tabs.TabPane>



                                            <Tabs.TabPane tab="Encouragement Groups" key="5">

                                                <div className="inner-circle">
                                                    <div className="create-inner-section encouragement-section-grid">


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p className="text-5xl">Sunday Scaries</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.encoutMonday} alt="sunday" />
                                                                    <p>Motivational Monday</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Meditation Station</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Mood food</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <div className="create-entertainment-circle">
                                                            <div className="encouragement-groups">

                                                                <div className="sunday-image">
                                                                    <img src={images.sunday} alt="sunday" />
                                                                    <p>Success City</p>
                                                                </div>

                                                                <div className="follow-btn-ps">
                                                                    <button>Follow</button>
                                                                </div>

                                                            </div>
                                                        </div>



                                                    </div>

                                                </div>


                                            </Tabs.TabPane>



                                        </Tabs>
                                    </div>

                                </div>

                            </div>


                        </div>

                    </div>

                </div>


                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal2Open}
                    closable={true}
                    onCancel={() => setModal2Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>
                            <div className="user-disp">
                                <p>Please select that what action that user can’t perform  </p>

                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="add-new-post-ps">
                                <p>Add New Post</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                            <div className="add-new-post-ps">
                                <p>Add Comment</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>


                            <div className="add-new-post-ps">
                                <p>Take New Appointments</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                            <div className="form-group number-of-days ">
                                <label>{appconstant.noDays}</label>
                                <Textfiled
                                    className='form-control '
                                    type='number'
                                    placeholder='Enter Days here' />

                                <div className="enter-chevron-down">
                                    <img src={images.chevronDown} alt="chevronDown" />
                                    <img src={images.chevronUP} alt="chevronUP" />
                                </div>
                            </div>
                        </div>


                        <div className="account-btn">
                            <button >Freeze Account</button>
                        </div>


                    </div>
                </Modal>

                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal1Open}
                    closable={true}
                    onCancel={() => setModal1Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user remove-profile-title">
                            <h1>Do you really want to</h1>
                            <h1>remove this Profile?</h1>
                        </div>

                        <div className="user-remove-section">
                            <img src={images.maleTable} alt="maleTable" />
                            <h5>Annette Black</h5>
                            <p>ckctm12@gmail.com</p>
                        </div>


                        <div className="account-btn cneter-butn">
                            <button >Remove Profile</button>
                        </div>


                    </div>
                </Modal>


                {/* Freeze Account */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal3Open}
                    closable={true}
                    onCancel={() => setModal3Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>

                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group  annette-black">
                                    <label>{appconstant.accountEmail}</label>
                                    <Textfiled
                                        className='form-control search-iocns '
                                        type='text'
                                        placeholder='Search by Email' />
                                    <p>This email is associated with <span>Annette Black</span></p>
                                </div>


                            </div>
                        </div>


                        <div className="account-btn">
                            <button onClick={() => {
                                setModal3Open(false)
                                setModal4Open(true)
                            }} >Freeze Account</button>
                        </div>
                    </div>
                </Modal>

                {/* Freeze Account  new post*/}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal4Open}
                    closable={true}
                    onCancel={() => setModal4Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Freeze Account</h1>
                            <div className="user-disp">
                                <p>Please select that what action that user can’t perform  </p>

                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="add-new-post-ps">
                                <p>Add New Post</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>

                            <div className="add-new-post-ps">
                                <p>Add Comment</p>
                                <Switch defaultChecked onChange={onChange3} />
                            </div>



                            <div className="form-group number-of-days ">
                                <label>{appconstant.noDays}</label>
                                <Textfiled
                                    className='form-control '
                                    type='number'
                                    placeholder='Enter Days here' />

                                <div className="enter-chevron-down">
                                    <img src={images.chevronDown} alt="chevronDown" />
                                    <img src={images.chevronUP} alt="chevronUP" />
                                </div>
                            </div>
                        </div>


                        <div className="account-btn">
                            <button >Freeze Account</button>
                        </div>


                    </div>
                </Modal>

                {/* Remove post */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal5Open}
                    closable={true}
                    onCancel={() => setModal5Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Remove Profile</h1>

                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group  annette-black">
                                    <label>{appconstant.accountEmail}</label>
                                    <Textfiled
                                        className='form-control search-iocns '
                                        type='text'
                                        placeholder='Search by Email' />
                                    <p>This email is associated with <span>Annette Black</span></p>
                                </div>


                            </div>
                        </div>


                        <div className="account-btn">
                            <button onClick={() => {
                                setModal5Open(false)
                                setModal6Open(true)
                            }} >Remove Profile</button>
                        </div>


                    </div>
                </Modal>

                {/* Remove post  new post*/}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    open={modal6Open}
                    closable={true}
                    onCancel={() => setModal6Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Remove Post</h1>
                            <div className="user-disp">
                                <p>Please enter reason to remove this post  </p>
                            </div>
                        </div>

                        <div className="description-inner-circle">
                            <div className="form-group">
                                <div className="textarea-label">
                                    <label>{appconstant.message}</label>
                                    <p>0/500</p>
                                </div>
                                <textarea
                                    rows="5" cols="50"
                                    className='form-control-textarea'
                                    type='textarea'
                                    placeholder='Enter Description' />
                            </div>
                        </div>


                        <div className="account-btn remove-post-btn">
                            <button >Send</button>
                        </div>


                    </div>
                </Modal>



            </div>



        )
    }
export default DirectCareReport

